import React, { useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { USER_URL } from '../api_base.js';
import { buildHeaders } from '../utils/apiHeaders.js';

// Since the access token lives in an httpOnly cookie, JS can't check locally
// whether the user is signed in. This guard asks the server (GET /users)
// once, then either renders the protected routes or redirects to /auth.
const AuthGuard = () => {
    const [status, setStatus] = useState("checking"); // checking | authed | guest

    const location = useLocation();

    useEffect(() => {
        let cancelled = false;

        const checkAuth = async () => {
            try {
                const res = await fetch(USER_URL + "/users", {
                    method: "GET",
                    credentials: "include",
                    headers: buildHeaders(),
                });

                if (cancelled) return;

                if (res.ok) {
                    setStatus("authed");
                } else {
                    setStatus("guest");
                }
            } catch (err) {
                if (!cancelled) setStatus("guest");
            }
        }

        checkAuth();
        return () => { cancelled = true; }
    }, []);

    if (status === "checking") {
        return (
            <div className="status_page">
                <span className="loading"></span>
            </div>
        )
    }

    if (status === "guest") {
        return <Navigate to="/auth" replace state={{ from: location }} />
    }

    return <Outlet />
}

export default AuthGuard;
